import { Ability } from '@casl/ability';
import { createContext } from 'react';
import { AbilityType, UsePermissionResponse } from './hooks';

interface ChannelPermissionsContextValue {
  channelId?: number;
  channelAbility: Ability<AbilityType>;
  canCreateCard: UsePermissionResponse;
  canUpdateCard: UsePermissionResponse;
  canDeleteCard: UsePermissionResponse;
  canReadThread: UsePermissionResponse;
  canCreateThread: UsePermissionResponse;
}

const defaultValue: ChannelPermissionsContextValue = {
  channelId: undefined,
  channelAbility: new Ability<AbilityType>(),
  canCreateCard: { enabled: false, loading: false },
  canUpdateCard: { enabled: false, loading: false },
  canDeleteCard: { enabled: false, loading: false },
  canReadThread: { enabled: false, loading: false },
  canCreateThread: { enabled: false, loading: false },
};

export const ChannelPermissionsContext =
  createContext<ChannelPermissionsContextValue>(defaultValue);
